<template>
  <div class="progress rounded-0" @click="seek()">
    <div class="progress-bar"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      v-bind:aria-valuenow="position"
      :style="{ width: position + '%' }"></div>
  </div>
</template>

<script>
  export default {

    name: 'ProgressBar',

    props: {
      position: {
        type: Number,
        required: false,
        default: 0
      }
    },

    methods: {
      seek (event) {
        event = window.event
        let currentPos = (event.offsetX / event.currentTarget.clientWidth) * 100
        this.$emit('seekTo', currentPos)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/color.scss";

  .progress {
    cursor: pointer;
    height: 3px;

    .progress-bar {
      background-color: $normal;
    }
  }
</style>



// WEBPACK FOOTER //
// ProgressBar.vue?793f9cd7